import React from 'react';
import { SVGAsset } from 'res';
import "./styles.css";

/**
 * @function BaseRowView
 * @param {React.Component} children - React components that's being placed to the immediate left of the right chevron. Not used in every row.
 * @param {STRING} leftIcon - The SVGAsset or ImageAsset get passed through using the leftIcon. Not always used or shown in every row.
  * @param {STRING} dataPoint - A optional key used if to make a unique data point for the rows. 
* @param {STRING} mainText - The top left text in the row. This text is always used in every row.
 * @param {STRING} subText - The text that is displayed beneath the mainText. Not always used or shown in every row.
 * @param {STRING} subTextClassName - Allows us to add a class name to the sub text. 
 * @param {STRING} className - Additional classes to add to the BaseRowView.
 * @return {React.Component}
 * @exported true
 * @description This is the BaseRowView. It is used as the template for all of the RowView variations.
 * @example
 * <BaseRowView className="addedClass" leftIcon="pizzaPlaceIcon" mainText="Pizza Place" subText="using card number **90" subTextClassName="capitalize">$12.34</BaseRowView>
 */
export default function BaseRowView(props) {
  const leftIcon = props.leftIcon ?? "";
  const mainText = props.mainText ?? "[Main Text]";
  const dataPoint = props.dataPoint ?{"data-point":props.dataPoint}:{};
  const subTextDataPoint = props.dataPoint ? { "data-point": props.dataPoint + "_Sub_Text" }: {};
  const subText = props.subText !== undefined ? (<div className={props.subTextClassName + " sub-text"} { ...subTextDataPoint }>{props.subText}</div>) : (<div></div>);
  const className = props.className ?? "";
  const id = props.id ?? "0";
  
  return (
    <div className={className + " base-row-view clickable"} onClick={props.onClick}>
      <div className="flex-container">
        { leftIcon }
        <div className="flex-container flex-vertical flex-width main-text">
          <div className="main-text"> <span  {...dataPoint} >{mainText}</span> </div>
          { subText }
        </div>
        <div className="set-width align-center-item children-text">
          {props.children}
        </div>
        <div className="set-width align-center-item right-chevron-icon" data-point={ `Row_Item_Chevron_${ id }` }>
          <SVGAsset id="RightChevronIcon" className="chevron-icon icon" />
        </div>
      </div>
    </div>
  );
}